import Rails from '@rails/ujs';
import '../controllers'
import Alpine from 'alpinejs'

Rails.start();
window.Alpine = Alpine
Alpine.start()